import { FaChevronDown, FaUserTie } from 'react-icons/fa';
import { useState, useParams, noDatapng, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle, moment, DataTable, BsSortUpAlt } from '../../common/common';

import MidReports from '../../middleware/Reports/MidReports';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import Navigations from '../../common/useNavigation';
import { MdManageAccounts, MdSell } from 'react-icons/md';
import { BsPersonBadge } from 'react-icons/bs';
import { decodeHTML } from '../../common/CommonFunctions';
import { useEffect } from 'react';

const Reports = () => {

    // const { getCategories } = MidViewCategories();

    const { navigateOrderDetails } = Navigations();


    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { values, users, userPlan, Remainuser, subUser, handleChange, handleFileChange, handleSubmit, fileInputRef } = MidReports(type);


    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }
    const [isLoading, setisLoading] = useState(false);


    const [buyerOpen, setBuyerOpen] = useState(false);
    const [selectedBuyer, setSelectedBuyer] = useState(null);

    const options = ["buyer", "user", "category", "products", "distributor"];
    const [selected, setSelected] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);

    const [buyerData, setBuyerData] = useState([]);
    const [usersData, setUsersData] = useState([])

    const [filteredUsers, setFilteredUsers] = useState([]);

    const [productData, setProductData] = useState([]);
    const [selectProduct, setSelectProduct] = useState("")
    const [searchText, setSearchText] = useState("");

    const [filteredData, setFilteredData] = useState([]);

    const [distributorData, setDistributorData] = useState([]);
    const [selectDistributor, setSelectDistributor] = useState(null)

    const GetReportData = async (options) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetSellerReports`, { options: options }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        if (options === "buyer") {
                            setBuyerData(response.data.buyer)
                            setUsersData([])
                            setFilteredUsers([])

                            setFilteredData([])
                            
                            setProductData([])
                        }
                        else if (options === "user") {
                            setUsersData(response.data.users)
                            setFilteredUsers(response.data.users)
                            setBuyerData([])

                            setFilteredData([])
                          
                            setProductData([])
                        }
                        else if (options === "category") {
                            setUsersData([]);
                            setFilteredUsers([]);
                            setBuyerData([])

                            setFilteredData([])
                           
                            setProductData([])
                        }
                        else if (options === "products") {
                            setProductData(response.data.product);
                           
                            setFilteredData(response.data.product)

                            setUsersData([]);
                            setFilteredUsers([]);
                            setBuyerData([])
                        }
                        else if (options === "distributor") {

                            setDistributorData(response.data.distributor)
                            setUsersData([]);
                            setFilteredUsers([]);
                            setBuyerData([])

                            setFilteredData([])
                        
                            setProductData([])

                        }
                    }
                    else if (response.data.success === 0) {
                        StopLoading(setisLoading);
                        showToast(response.data.message, 'error');
                    }
                }).catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find seller details, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    }

    const columns = [
        {
            name: "Order ID",
            style: {
                color: '#0089ff ',
                fontSize: '14px',
                fontWeight: '500',
                padding: '8px 16px',
            },
            sortable: true,
            //selector: (row) => row.order_unique_key,
            cell: row => {
                function getKeyByValue(object, row) {
                    return object[row];
                }
                return (
                    <a
                        className="productName"
                        onClick={() => navigateOrderDetails(row.order_unique_key, type)}
                        rel="noopener noreferrer">
                        {row.order_unique_key}

                    </a>
                );
            },
        },
        {
            name: "Supplier Name",

            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.full_name,
        },
        {
            name: 'Total Quantity',

            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.total_quantity
        },
        {
            name: 'Total Amount',
            style: {
                color: 'black',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => (parseFloat(row.ammount) || 0).toFixed(2)
        },
        {
            name: 'Order Date',

            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => moment(row.order_created_date).format(' MMM DD YYYY'),
        },

        {
            name: "Order Status",
            sortable: true,
            conditionalCellStyles: [
                {
                    when: row => row.order_status !== undefined,
                    style: row => {
                        const statusMap = {
                            1: { label: 'Order Placed', color: 'green' },
                            2: { label: 'Confirm', color: 'green' },
                            3: { label: 'On Hold', color: 'red' },
                            4: { label: 'On Process', color: 'brown' },
                            5: { label: 'Packed', color: 'blue' },
                            6: { label: 'Dispatch', color: 'orange' },
                            7: { label: 'Complete', color: 'purple' },
                            8: { label: 'On Transit', color: 'skyblue' },
                            9: { label: 'Delivered', color: 'maroon' },
                            10: { label: 'Cancelled', color: 'aqua' },
                            11: { label: 'Out of Stock', color: 'red' },
                        };

                        const status = statusMap[row.order_status] || { label: null, color: 'gray' };

                        return {
                            fontSize: '14px',
                            fontWeight: '700',
                            color: status.color,
                        };
                    },
                },
            ],
            selector: (row) => {
                const statusMap = {
                    1: 'Order Placed',
                    2: 'Confirm',
                    3: 'On Hold',
                    4: 'On Process',
                    5: 'Packed',
                    6: 'Dispatch',
                    7: 'Complete',
                    8: 'On Transit',
                    9: 'Delivered',
                    10: 'Cancelled',
                    11: 'Out of Stock',
                };

                return statusMap[row.order_status] || null;
            },
        },
        {
            name: 'Update Date',
            width: '150px',
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => moment(row.order_modified_date).format(' MMM DD YYYY'),
        },
    ]

    const columns2 = [
        {
            name: "User Name",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.full_name,
        },
        {
            name: "Email Address",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.email,
        },
        {
            name: "Mobile Number ",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.mobile,
        },
        {
            name: "User Type",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => 'Manager',
        },
        {
            name: "Status",
            style: {
                color: 'black',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => (
                <span
                    className={`px-3 py-1 rounded-full text-white text-xs font-medium ${row.status === 0 ? 'bg-red-500' : 'bg-green-500'
                        }`}
                >
                    {row.status === 0 ? 'Inactive' : 'Active'}
                </span>
            ),
        },
        {
            name: "Users",
            selector: (row) => {
                let roleLabel = "Other";
                let roleIcon = <BsPersonBadge className="text-gray-500" />;
                let roleColor = "bg-gray-100 text-gray-700";

                if (row.user_type_id === 1) {
                    roleLabel = "Manager";
                    roleIcon = <FaUserTie className="text-blue-600" />;
                    roleColor = "bg-blue-100 text-blue-700";
                } else if (row.user_type_id === 2) {
                    roleLabel = "Salesman";
                    roleIcon = <MdSell className="text-green-600" />;
                    roleColor = "bg-green-100 text-green-700";
                }

                return (
                    <div className="flex items-center gap-2">
                        <div
                            className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium shadow-sm ${roleColor}`}
                        >
                            {roleIcon}
                            <span>{roleLabel}</span>
                        </div>
                    </div>
                );
            },
        }
    ]

    const [selectedRole, setSelectedRole] = useState(null);

    const roles = [
        {
            name: 'Manager',
            icon: <MdManageAccounts />,
        },
        {
            name: 'Salesman',
            icon: <FaUserTie />,
        },
    ];

    const handleRoleChange = (roleName) => {
        setSelectedRole(roleName);

        if (!roleName) {
            setFilteredUsers(usersData); // agar role clear ho jaye to sabhi show karo
        } else {
            setFilteredUsers(
                usersData.filter((u) =>
                    roleName === "Manager"
                        ? u.user_type_id === 1
                        : roleName === "Salesman"
                            ? u.user_type_id === 2
                            : true
                )
            );
        }
    };

    const columns3 = [
        {
            name: 'Image',
            selector: (row) => {
                const imageSrc = row.image
                    ? `${process.env.REACT_APP_API_URL}/api/uploads/category/${row.image}`
                    : `${process.env.REACT_APP_API_URL}/uploads/noproductphoto.png`;

                return (

                    <div className="w-[70px] h-[70px] overflow-hidden flex items-center justify-center">
                        <img
                            className='p-2 rounded-xl shadow'
                            width={100}
                            height={100}
                            src={imageSrc}
                            alt={row.image ? 'Category Image' : 'No Image Available'}
                        />
                    </div>
                );
            }
        },
        {
            name: "Name",
            style: {
                color: 'black',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            cell: (row) => {
                const handleClick = () => {
                    getCategories(row.id);
                    // gobackCategoryfn(row.parent_category_id);
                };

                return (
                    <button
                        className="productName"
                        onClick={handleClick}
                        style={{ background: 'none', border: 'none', color: '#196ef9', cursor: 'pointer', padding: 0, }}
                    >
                        {decodeHTML(row.name)}
                    </button>
                );
            },
        },
        // {
        //     name: " Status ",
        //     sortable: true,
        //     cell: (row) => (
        //         <div className="flex items-center gap-2">

        //             {ActiveUser === 1 &&
        //                 <label className="relative inline-flex items-center cursor-pointer">

        //                     <input
        //                         type="checkbox"
        //                         checked={row.status === 1}
        //                         onChange={() => handleToggleStatus(row.CategoryUID, !row.status)}
        //                         className="sr-only peer"
        //                     />
        //                     <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-green-500 transition-colors duration-300"></div>
        //                     <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
        //                 </label>
        //             }
        //             <span className="text-sm font-medium">
        //                 {row.status === 1 ? "Active" : "Inactive"}
        //             </span>
        //         </div>
        //     ),
        // },
        // {
        //     name: "Active",
        //     sortable: true,
        //     conditionalCellStyles: [
        //         {
        //             when: row => row.status === 1,
        //             style: { color: 'green', fontWeight: '500', },
        //         },
        //         {
        //             when: row => row.status === 0,
        //             style: { fontWeight: '500', color: 'red', },
        //         },
        //     ],
        //     selector: (row) => {
        //         const data = row.status;
        //         return (
        //             data === 1 ? 'Active '
        //                 : 'In Active '
        //         )
        //     }
        // },
        // {
        //     name: "Visible",
        //     sortable: true,
        //     conditionalCellStyles: [
        //         {
        //             when: row => row.visible === 1,
        //             style: { color: 'green', fontWeight: '500' },
        //         },
        //         {
        //             when: row => row.visible === 0,
        //             style: { fontWeight: '500', color: 'red' },
        //         },
        //     ],
        //     selector: (row) => {
        //         const data = row.visible;
        //         return data === 1 ? 'Visible' : 'Not Visible';
        //     }
        // },
        // {
        //     name: "Action",
        //     selector: (row) => <div className='flex flex-col lg:flex-row space-x-2 '>
        //         {/* <button className='btn btn-warning  p-3 rounded-full mx-1 ' onClick={() => navigatesubgategories(row.category_unique_id)}><FaEye /></button> */}

        //         {ActiveUser === 1 &&
        //             <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ebebeb] !text-black !border-[#d1d1d1]" onClick={() => { handleShowModal(row.id, row.name); }}>
        //                 Add sub category
        //             </Button>
        //         }

        //         {ActiveUser === 1 &&
        //             <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10" onClick={() => handleShowEditModal(row.CategoryUID, row.id, row.name, row.image)}>
        //                 <FaPencilAlt className='text-[#193b99] m-auto' />
        //             </Button>
        //         }

        //         {ActiveUser === 1 &&
        //             <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10 text-center " onClick={() => deleteCategory(row.id)}>
        //                 <FaTrash className='text-red-700 m-auto' />
        //             </Button>
        //         }

        //     </div>,
        // },
    ]

    const [categoryID, setCategoryID] = useState(0);

    const getCategories = async (categoryID) => {
        // console.log(categoryID);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetCategories`, { categoryID }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    if (response.data.success === 1) {
                        showToast(response.data.message, 'success');
                        setCategories(response.data.data);
                        setFilteredCategories(response.data.data);
                        // setSheetdata(response.data.data);
                        // setbackCategoryId((prevValues) => {
                        //     if (Array.isArray(prevValues)) {
                        //         return [...prevValues, categoryID]; // Only spread if it's an array
                        //     }
                        //     // return [categoryID]; // Default case, if prevValues is not an array
                        // });
                        // setbackCategoryId(prevValues => [...prevValues, categoryID]);
                    }
                    else {
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Get Categories, please try again later ", 'error');
        }
    };
    
    useEffect(() => {
        getCategories(categoryID);
    }, []);

    useEffect(() => {
        if (selectProduct) {
            // productData के orderDetails में से match कर के filter करेंगे
            const newData = productData.filter((order) =>
                order.orderDetails?.some(
                    (detail) =>
                        detail.product_name?.toLowerCase() === selectProduct.toLowerCase()
                )
            );
            setFilteredData(newData);
        } else {
            // अगर कोई product select नहीं है तो सब दिखाएँ
            setFilteredData(productData);
        }
    }, [selectProduct, productData]);

    const tableConfig = {
        buyer: {
            columns: columns,
            data: selectedBuyer?.orders || []
        },
        // category: {
        //     columns: categoryColumns,
        //     data: categoryData || []
        // },
        products: {
            columns: columns,
            data: filteredData || []
        },
        distributor: {
            columns: columns,
            data: selectDistributor?.orders || []
        }
    };

    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full p-3">
                    {/* Panel Card */}
                    <div className="bg-white rounded-2xl  border p-5">
                        {/* Header */}
                        <div className="mb-4">
                            <h1 className="text-lg font-bold text-[#1e3a8a]">Reports</h1>
                            <p className="text-gray-600 text-sm mt-1">
                                A product category is a group of similar type of products.
                                Ex. Menswear, Womenswear, Childrenswear
                            </p>
                        </div>

                        <div className="flex flex-row justify-between items-center">
                            {/* Dropdown */}
                            <div className="flex flex-row gap-4 items-center">
                                {/* First Dropdown */}
                                <div className="relative w-64">
                                    <div
                                        className="flex items-center justify-between border-2 border-gray-300 rounded-xl px-4 py-2.5 bg-white cursor-pointer  hover:bg-gray-50 transition-colors duration-150"
                                        onClick={() => setIsOpen(!isOpen)}
                                    >
                                        <span className="text-gray-700 font-medium">{selected ? selected : "Select option"}</span>
                                        <FaChevronDown
                                            className={`text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : "rotate-0"}`}
                                        />
                                    </div>

                                    {isOpen && (
                                        <ul className="absolute left-0 right-0 mt-2 border-2 border-gray-300 rounded-xl shadow-lg bg-white z-10">
                                            {options.map((option, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => {
                                                        setSelected(option);
                                                        setIsOpen(false);
                                                        GetReportData(option)
                                                        if (option === "buyer") {
                                                            setBuyerOpen(true);
                                                        } else {
                                                            setBuyerOpen(false);
                                                        }
                                                    }}
                                                    className={`px-5 py-2.5 cursor-pointer transition-colors duration-150 rounded-md
                    ${selected === option ? "bg-blue-100 text-blue-800 font-semibold" : "text-gray-700 hover:bg-gray-100"}`}
                                                >
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>

                                {selected === "buyer" && (
                                    <div className="relative w-64">
                                        {/* Buyer Dropdown Header */}
                                        <div
                                            className="flex items-center justify-between border-2 border-gray-300 rounded-xl px-4 py-2.5 bg-white cursor-pointer  hover:bg-gray-50 transition-colors duration-150"
                                            onClick={() => setBuyerOpen(!buyerOpen)} // list toggle
                                        >
                                            <span className="text-gray-700 font-medium">
                                                {selectedBuyer ? selectedBuyer.full_name : "Select buyer"}
                                            </span>
                                            <FaChevronDown
                                                className={`text-gray-500 transition-transform duration-200 ${buyerOpen ? "rotate-180" : "rotate-0"}`}
                                            />
                                        </div>

                                        {/* Buyer List */}
                                        {buyerOpen && (
                                            <ul className="absolute left-0 right-0 mt-2 border-2 border-gray-300 rounded-xl shadow-lg bg-white z-10 ">
                                                {buyerData.map((buyer, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => {
                                                            setSelectedBuyer(buyer);
                                                            setBuyerOpen(false); // only list will close, not the whole dropdown
                                                        }}
                                                        className={`px-5 py-2.5 cursor-pointer rounded-md transition-colors duration-150
                        ${selectedBuyer?.distributor_supplier_id === buyer.distributor_supplier_id
                                                                ? "bg-blue-100 text-blue-800 font-semibold"
                                                                : "text-gray-700 hover:bg-gray-100"
                                                            }`}
                                                    >
                                                        {buyer.full_name}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                )}

                                {selected === "user" &&
                                    <div className="flex items-center justify-center bg-gray-100 font-sans">
                                        <div className="bg-white rounded-2xl w-full max-w-lg">
                                            <div className="flex flex-col md:flex-row gap-6 justify-center">
                                                {roles.map((role) => (
                                                    <label
                                                        key={role.name}
                                                        className={`relative flex flex-col items-center justify-center p-2.5 rounded-2xl cursor-pointer border-4 transition-all duration-300 ease-in-out bg-gray-200 ${selectedRole === role.name
                                                            ? "border-indigo-500 scale-105"
                                                            : "border-transparent hover:border-indigo-300 transform hover:scale-105"
                                                            }`}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="role"
                                                            value={role.name}
                                                            checked={selectedRole === role.name}
                                                            onChange={() => handleRoleChange(role.name)}
                                                            className="absolute opacity-0 w-0 h-0"
                                                        />

                                                        <div className="flex flex-row items-center gap-3">
                                                            {role.icon}
                                                            <span className="text-sm md:text-base font-medium text-gray-800">
                                                                {role.name}
                                                            </span>
                                                        </div>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                }

                                {selected === "products" && (
                                    <div className="relative w-64">
                                        <div className="flex items-center justify-between border-2 border-gray-300 rounded-xl px-4 py-2.5 bg-white cursor-pointer hover:bg-gray-50 transition-colors duration-150" onClick={() => setBuyerOpen(!buyerOpen)} >
                                            <span className="text-gray-700 font-medium">
                                                {selectProduct ? selectProduct : "Select Product"}
                                            </span>
                                            <FaChevronDown
                                                className={`text-gray-500 transition-transform duration-200 ${buyerOpen ? "rotate-180" : "rotate-0"
                                                    }`}
                                            />
                                        </div>

                                        {/* Dropdown List */}
                                        {buyerOpen && (
                                            <div className="absolute left-0 right-0 mt-2 border-2 border-gray-300 rounded-xl shadow-lg bg-white z-10 ">
                                                {/* Search Box */}
                                                <div className="p-2 border-b">
                                                    <input
                                                        type="text"
                                                        placeholder="Search product..."
                                                        value={searchText}
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                                                    />
                                                </div>

                                                <ul className="max-h-60 overflow-y-auto">
                                                    {Array.from(
                                                        new Set(
                                                            productData.flatMap((order) =>
                                                                order.orderDetails?.map((d) => d.product_name)
                                                            )
                                                        )
                                                    )
                                                        .filter((name) =>
                                                            name?.toLowerCase().includes(searchText.toLowerCase())
                                                        )
                                                        .map((name, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => {
                                                                    setSelectProduct(name);
                                                                    setBuyerOpen(false);
                                                                    setSearchText("");
                                                                }}
                                                                className={`px-5 py-2.5 cursor-pointer rounded-md transition-colors duration-150 ${selectProduct === name
                                                                    ? "bg-blue-100 text-blue-800 font-semibold"
                                                                    : "text-gray-700 hover:bg-gray-100"
                                                                    }`}
                                                            >
                                                                {name}
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {selected === "distributor" && (
                                    <div className="relative w-64">
                                        {/* Buyer Dropdown Header */}
                                        <div
                                            className="flex items-center justify-between border-2 border-gray-300 rounded-xl px-4 py-2.5 bg-white cursor-pointer  hover:bg-gray-50 transition-colors duration-150"
                                            onClick={() => setBuyerOpen(!buyerOpen)} // list toggle
                                        >
                                            <span className="text-gray-700 font-medium">
                                                {selectDistributor ? selectDistributor.full_name : "Select Distributor"}
                                            </span>
                                            <FaChevronDown
                                                className={`text-gray-500 transition-transform duration-200 ${buyerOpen ? "rotate-180" : "rotate-0"}`}
                                            />
                                        </div>

                                        {/* Buyer List */}
                                        {buyerOpen && (
                                            <ul className="absolute left-0 right-0 mt-2 border-2 border-gray-300 rounded-xl shadow-lg bg-white z-10 ">
                                                {distributorData.map((buyer, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => {
                                                            setSelectDistributor(buyer);
                                                            setBuyerOpen(false); // only list will close, not the whole dropdown
                                                        }}
                                                        className={`px-5 py-2.5 cursor-pointer rounded-md transition-colors duration-150
                        ${selectDistributor?.distributor_supplier_id === buyer.distributor_supplier_id
                                                                ? "bg-blue-100 text-blue-800 font-semibold"
                                                                : "text-gray-700 hover:bg-gray-100"
                                                            }`}
                                                    >
                                                        {buyer.full_name}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                )}

                            </div>

                        </div>

                        {tableConfig[selected] && tableConfig[selected].data.length > 0 ? (
                            <DataTable
                                className="scrollhost"
                                columns={tableConfig[selected].columns}
                                data={tableConfig[selected].data}
                                pagination
                                responsive
                                sortIcon={<BsSortUpAlt className="mx-1" />}
                            />
                        ) : (
                            <div>
                                {selected !== "user" &&
                                    <div className="flex flex-col items-center justify-center">
                                        <img src={noDatapng} alt="No Data" height={260} width={260} />
                                        <h1 className="text-lg text-gray-300 font-bold mt-4">
                                            Oops! No Data Found
                                        </h1>
                                    </div>
                                }
                            </div>
                        )}


                        {selected === "user" &&
                        <div>
                              {filteredUsers.length > 0 ? (
                            <DataTable
                                className="scrollhost"
                                columns={columns2}
                                data={filteredUsers}
                                pagination
                                responsive
                                sortIcon={<BsSortUpAlt className="mx-1" />}
                            />
                        ) : (
                            <div>
                                {selected == "user" &&

                                    < div className="flex flex-col items-center justify-center">
                                        <img src={noDatapng} alt="No Data" height={260} width={260} />
                                        <h1 className="text-lg text-gray-300 font-bold mt-4">
                                            Oops! No Data Found
                                        </h1>
                                    </div>
                                }
                            </div>
                        )}

                        </div>
                        }
                      


                        {/* {filteredCategories && filteredCategories.length > 0 ? (
                            <DataTable
                                columns={columns3}
                                data={filteredCategories}
                                pagination
                                sortIcon={<MdArrowDownward />}
                            />

                        ) : (
                            <center>
                                <img src={noDatapng} height={300} width={300} alt="No Data Exist" />
                                <h1 className='text-lg -translate-y-10 text-gray-300 font-bold'> No Data Exist! </h1>
                            </center>
                        )} */}

                    </div>
                </div>
            </div>
        </div >
    )
}

export default Reports